"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STUDY_PERMIT_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.STUDY_PERMIT_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_GETTING_STARTED_PART1",
        title: "Your Personal Information",
        subtitle: "Please confirm your full legal name and your date or birth (as shown on your passport).",
        id: 81,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
            Question["Date of Birth"].label("PD_7"),
            Question["Will you be traveling to Canada with both (or all) your parent(s) or legal guardian(s)?"].label("EDU_26"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_GETTING_STARTED_PART2",
        title: "Your Location Information",
        subtitle: "Please complete the questions below related to your citizenship, residence, and where you plan on studying.",
        id: 82,
        content: [
            Question["Country of Citizenship"].label("PD_10"),
            // Question["Current country of residence"].label("CR_1"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
            Question["Which province is your study program located in?"].label("EDU_9"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_GETTING_STARTED_PART3",
        title: "Your Family Information",
        subtitle: "You are allowed to bring immediate family members with you to Canada. If you plan on bringing family members, please add them all below.",
        id: 83,
        content: [
            Question["Are you bringing any family members (spouse, common-law partner, children) with you to Canada?"]
                .label("PD_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["If you are bringing a spouse, common law partner and/or children with you to Canada, please add each of them here!"].label("CUS_1"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_INTENDED_STUDY_DETAILS",
        title: "Details of intended study in Canada",
        subtitle: undefined,
        id: 84,
        content: [
            Question["What is the name of the school or institution that you will be attending?"].label("EDU_10"),
            Question["School or program start date"].label("EDU_22"),
            Question["School or program end date"].label("EDU_23"),
            Question["Level of study"].label("EDU_11"),
            Question["Field of study"].label("EDU_12"),
            Question["School street address"].label("EDU_13"),
            Question["School city or town"].label("EDU_14"),
            Question["School province"].label("EDU_15"),
            Question["School postal code"].label("EDU_33"),
            Question["Total cost of tuition (CAD)"].label("EDU_16"),
            Question["Total cost of room and board (CAD)"].label("EDU_17"),
            Question["Total other costs (CAD)"].label("EDU_18"),
            Question["Total funds available for duration of stay (CAD)"].label("EDU_19"),
            Question["Who will pay for your expenses while in Canada?"]
                .label("EDU_20")
                .ifAnswerEquals(answer_1.answer.other)
                .renderTheseQuestions([
                Question["Who (other) will pay for your expenses while in Canada?"].label("EDU_21"),
            ]),
            Question["Designated Learning Institution number (O#)"].label("EDU_24"),
            Question["Student ID number"].label("EDU_25"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_BACKGROUND_INFORMATION",
        title: "Background Information",
        subtitle: undefined,
        id: 85,
        content: [
            Question["Within the past two years, have you or a family member ever had tuberculosis of the lungs or have been in close contact with a person with tuberculosis?"]
                .label("BI_1")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details and the name of the family members (if applicable)"].label("BI_2"),
            ]),
            Question["Do you have any physical or mental disorders that would require you social and/or health services, other than medication, during a stay in Canada?"]
                .label("BI_3")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide more details"].label("BI_4"),
            ]),
            Question["Have you ever remained beyond the validity of your status, attended school without authorization or worked without authorization in Canada?"]
                .label("BI_5")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_6"),
            ]),
            Question["Have you ever been refused a visa or permit, denied entry or ordered to leave Canada or any other country or territory?"]
                .label("BI_7")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_8"),
            ]),
            Question["Have you previously applied to enter or remain in Canada?"]
                .label("BI_9")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_10"),
            ]),
            Question["Have you ever commited, been arrested for, been charged with or convicted of any criminal offence in any country or territory?"]
                .label("BI_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_12"),
            ]),
            Question["Did you serve in any military, militia, or civil defence unit or serve in a security organization or police force (including non obligatory national service, reserve or volunteer units)?"]
                .label("BI_13")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide dates of service and countries or territories where you served"].label("BI_14"),
                Question["Please provide all the details about your military service below"].label("CUS_8"),
            ]),
            Question["Are you, or have you ever been a member or associated with any political party, or other group or organization which has engaged in or advocated violence as a means to achieving political or religious objectiv, or which has been assoicated with criminal activity at the time?"]
                .label("BI_15")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide all the details about your involvement with political parties or other organizations"].label("CUS_9"),
            ]),
            Question["Have you ever witnessed or participated in ill treatment of prisoners or civilians, looting or desecration of religious buidlings?"]
                .label("BI_16")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide all the details about your involvement with ill treatment of prisoners or civilians, looting or desecration of religious buidlings"].label("CUS_10"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_CUSTODIAN_MINOR",
        title: "Minor traveling to Canada (Custodianship Declaration)",
        subtitle: "If you are 18 years of age or younger, you will be required to have a legal custodian located in Canada. We require additional information and you will need approval from your parent(s) or legal guardian.",
        id: 90,
        content: [
            Question["Birth certificate number"].label("PD_14"),
            Question["Birth certificate issuing Country"].label("PD_15"),
            Question["Where will you live (reside) while studying in Canada?"].label("HEAD_6"),
            Question["Street number"].label("EDU_27"),
            Question["Street name"].label("EDU_28"),
            Question["Apt or Unit number"].label("EDU_29"),
            Question["City or Town"].label("EDU_30"),
            Question["Province"].label("EDU_31"),
            Question["Postal Code"].label("EDU_32"),
            Question["Information about your primary parent or legal guardian"].label("HEAD_7"),
            Question["First name(s)"].label("GUA_1"),
            Question["Last name"].label("GUA_2"),
            Question["Date of Birth"].label("GUA_3"),
            Question["Street number"].label("GUA_4"),
            Question["Street name"].label("GUA_5"),
            Question["Apt or Unit number"].label("GUA_6"),
            Question["City or Town"].label("GUA_7"),
            Question["Province or State"].label("GUA_8"),
            Question["Country or Territory"].label("GUA_9"),
            Question["Postal code or ZIP code"].label("GUA_10"),
            Question["Telephone number"].label("GUA_11"),
            Question["Email address"].label("GUA_12"),
            Question["Do you have another parent or legal guardian that you would like to add?"]
                .label("GUA_13")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Information about your secondary parent or legal guardian"].label("HEAD_8"),
                Question["First name(s)"].label("GUA_14"),
                Question["Last name"].label("GUA_15"),
                Question["Date of Birth"].label("GUA_16"),
                Question["Street number"].label("GUA_17"),
                Question["Street name"].label("GUA_18"),
                Question["Apt or Unit number"].label("GUA_19"),
                Question["City or Town"].label("GUA_20"),
                Question["Province or State"].label("GUA_21"),
                Question["Country or Territory"].label("GUA_22"),
                Question["Postal code or ZIP code"].label("GUA_23"),
                Question["Telephone number"].label("GUA_24"),
            ]),
            Question["Information about your custodian who is located in Canada"].label("HEAD_9"),
            Question["First name(s)"].label("GUA_25"),
            Question["Last name"].label("GUA_26"),
            Question["Date of Birth"].label("GUA_27"),
            Question["Street number"].label("GUA_28"),
            Question["Street name"].label("GUA_29"),
            Question["Apt or Unit number"].label("GUA_30"),
            Question["City or Town"].label("GUA_31"),
            Question["Province"].label("GUA_32"),
            Question["Postal Code"].label("GUA_33"),
            Question["Telephone number"].label("GUA_34"),
            Question["Status in Canada"].label("GUA_35"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_CURRENT_COUNTRY_RESIDENCE",
        title: "Current Country of Residence",
        subtitle: "Your current country of residence has already been selected during your onboarding. Go to your account page to update it.",
        id: 91,
        content: [
            Question["Current country of residence status"]
                .label("CR_2")
                .ifAnswerEquals(answer_1.answer.other)
                .renderTheseQuestions([
                Question["Current country of residence other status"].label("CR_3"),
            ]),
            Question["Current country of residence from date"].label("CR_4"),
            Question["Current country of residence to date"].label("CR_5"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_MINOR_CONSENT",
        title: "Minor traveling to Canada",
        subtitle: "If you are 17 (or 18 in certain provinces) years of age or younger, you will require consent from your parent(s) or legal guardian(s) if you are traveling alone.",
        id: 92,
        content: [
            Question["Birth certificate number"].label("PD_14"),
            Question["Birth certificate issuing Country"].label("PD_15"),
            Question["Where will you live (reside) while studying in Canada?"].label("HEAD_6"),
            Question["Street number"].label("EDU_27"),
            Question["Street name"].label("EDU_28"),
            Question["Apt or Unit number"].label("EDU_29"),
            Question["City or Town"].label("EDU_30"),
            Question["Province"].label("EDU_31"),
            Question["Postal Code"].label("EDU_32"),
            Question["Information about your primary parent or legal guardian"].label("HEAD_7"),
            Question["First name(s)"].label("GUA_1"),
            Question["Last name"].label("GUA_2"),
            Question["Date of Birth"].label("GUA_3"),
            Question["Street number"].label("GUA_4"),
            Question["Street name"].label("GUA_5"),
            Question["Apt or Unit number"].label("GUA_6"),
            Question["City or Town"].label("GUA_7"),
            Question["Province or State"].label("GUA_8"),
            Question["Country or Territory"].label("GUA_9"),
            Question["Postal code or ZIP code"].label("GUA_10"),
            Question["Telephone number"].label("GUA_11"),
            Question["Email address"].label("GUA_12"),
            Question["Do you have another parent or legal guardian that you would like to add?"]
                .label("GUA_13")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Information about your secondary parent or legal guardian"].label("HEAD_8"),
                Question["First name(s)"].label("GUA_14"),
                Question["Last name"].label("GUA_15"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMING_INTO_CANADA",
        title: "Coming to Canada Details",
        subtitle: "Provide the details when you first came to Canada",
        id: 107,
        content: [
            Question["What day did you first come to Canada on?"].label("TR_12"),
            Question["What city and province did you arrive in when you first came to Canada?"].label("TR_13"),
            Question["What was your original purpose for coming to Canada?"]
                .label("TR_14")
                .ifAnswerEquals(answer_1.answer.other)
                .renderTheseQuestions([
                Question["Other original purpose for coming to Canada"].label("TR_15"),
            ]),
            Question["What day did you most recently come to Canada on?"].label("TR_16"),
            Question["What city and province did you most recently arrive in when coming to Canada?"].label("TR_17"),
            Question["Provide the document number of the most recent Visitor Record, Study Permit, Work Permit or Temporary Resident Permit issued to you"].label("TR_18"),
        ],
    }),
];
